import React from 'react';

import { HeroV2, BulletedList } from '@zola/zola-ui';

import AllGiftsRegistry from 'assets/images/website/registryOnboard/AllGiftsRegistry';

import BuildZolaRegistryCTA from '../../../components/BuildZolaRegistryCTA';
import SeeSamplePageLink from '../../../components/SeeSamplePageLink';

import styles from './StartYourRegistryHero.module.less';

const StartYourRegistryHero = () => {
  return (
    <div className={styles.container}>
      <HeroV2
        backgroundImage={AllGiftsRegistry}
        className={styles.heroContainer}
        title="Start Your Registry"
        headerTag="h3"
        displayAsBlockImage
        body={
          <div className={styles.bulletListContainer}>
            <BulletedList color="teal">
              <>
                <li>Add gifts from any online store, all in one place</li>
                <li>Guests shop everything on your wedding website</li>
                <li>Get one-on-one support you won&apos;t find anywhere else</li>
              </>
            </BulletedList>
          </div>
        }
        buttons={
          <div className={styles.ctaContainer}>
            <BuildZolaRegistryCTA
              ctaText="Get Started With a Fun Quiz"
              className={styles.btnSpacing}
            />
            <SeeSamplePageLink />
          </div>
        }
      />
    </div>
  );
};

export default StartYourRegistryHero;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/StartYourRegistryHero/StartYourRegistryHero.jsx